import { Stack, Divider } from "@mantine/core"
import { Loader } from "@tfg/ui"
import { useMemo } from "react"

import { ExtraCustomFields } from "~/pages/SupplierPortal/TraceabilityRequests/components/ExtraCustomFields"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/TraceabilityOperationsContext"
import { hasOperation } from "~/pages/SupplierPortal/TraceabilityRequests/utils"

import { CustomFieldInput } from "./CustomFieldInput"

type Props = {
  isLoading: boolean
}

export const OperationCustomFields = ({ isLoading }: Props) => {
  const {
    operationItem,
    operationItems,
    status,
    isTransferred,
    isReinforcedTraceability,
  } = useTraceabilityOperations()
  const customFieldDefs = useMemo(
    () => operationItem.customFieldDefs.filter((cfd) => !cfd.onActivityId),
    [operationItem.customFieldDefs]
  )

  if (
    (operationItem.customFieldDefs.length === 0 &&
      operationItem.extraCustomFieldDefs.length === 0) ||
    isTransferred ||
    !operationItem.operation ||
    isReinforcedTraceability
  ) {
    return null
  }

  return (
    <Stack>
      <Stack gap={0} p="xs">
        <Divider />
      </Stack>
      <Stack gap="xs">
        {customFieldDefs.map((cfd) =>
          isLoading ? (
            <Loader
              size="xs"
              fullPage
              key={`${cfd.id}-${operationItem.nodeId}`}
            />
          ) : hasOperation(operationItem) ? (
            <CustomFieldInput
              key={`${cfd.id}-${operationItem.nodeId}`}
              cfd={cfd}
              operationItem={operationItem}
              doNotKnow={isTransferred}
              status={status}
              isLoading={isLoading}
            />
          ) : null
        )}
        <ExtraCustomFields
          operationItem={operationItem}
          operationItems={operationItems}
          doNotKnow={isTransferred}
          status={status}
          isLoading={isLoading}
        />
      </Stack>
    </Stack>
  )
}
